import styled from 'styled-components';

const NumpadGrid = styled.div`
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: ${({theme})=>theme.spacing[2]}; margin-bottom: ${({theme})=>theme.spacing[4]};

`;

export default NumpadGrid;


